import * as Actions from './actions'
import initialState from '../store/initialState'

export const ReservecountReducer = (state = initialState.reservecount, action: any) => {
    switch (action.type) {
        case Actions.SET_RESERVECOUNT_VALUE:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}